module.exports = __webpack_public_path__ + "static/media/asi-gutenblock.08df9c57.png";